module.exports = __webpack_public_path__ + "img/navlogo.6292b515.png";